import { render, staticRenderFns } from "./HistogramSlider.vue?vue&type=template&id=b6f0baa8&"
import script from "./HistogramSlider.vue?vue&type=script&lang=js&"
export * from "./HistogramSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports